// @ts-nocheck
import { ExclamationCircleIcon } from '@heroicons/react/20/solid';
import { BanknotesIcon, BuildingOffice2Icon, EnvelopeIcon, GlobeAltIcon, IdentificationIcon, LockClosedIcon, MapPinIcon } from "@heroicons/react/24/outline";
import axios from "axios";
import React, { useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { Tooltip } from 'react-tooltip';
import Breadcrumb from "../../components/breadcrumb/breadcrumb";
import { URL } from '../../service/Service';
import ErrorMessage from '../../components/ErrorMessage';
import SuccessMessage from '../../components/SuccessMessage';

const normalizeWebsite = (website) => {
    const trimmedWebsite = website.trim();
    return /^https?:\/\//i.test(trimmedWebsite)
        ? trimmedWebsite
        : `https://${trimmedWebsite}`;
};

export default function Create() {
    const pages = [
        { name: 'Lista de Parceiros', href: '/admin/parceiros', current: false },
        { name: 'Criar Parceiro', href: '/admin/criar-parceiro', current: true },
    ];
    const [formData, setFormData] = useState({
        email: '',
        nif: '',
        name: '',
        adress: '',
        zipCode: '',
        notes: '',
        url: '',
        iban: '',
        softwareType: 'NA',  // ALWAYS SET A DEFAULT VALUE (NA) TO AVOID EMPTY VALUES - REQUIRED TO CREATE A NEW PARTNER (ignore - not used, but its not to delete)
        bicSwift: '',
    });

    const [messageErr, setMessageErr] = useState("");
    const [subtitleErr, setSubtitleErr] = useState("");
    const [successMessage, setSuccessMessage] = useState('');
    const navigate = useNavigate();

    // add state variables to track errors for each field
    const [emailError, setEmailError] = useState('');
    const [nifError, setNifError] = useState('');
    const [nameError, setNameError] = useState('');
    const [bicSwiftError, setBicSwiftError] = useState('');
    const [adressError, setAddressError] = useState('');
    const [zipCodeError, setZipCodeError] = useState('');
    const [urlError, setUrlError] = useState('');
    const [ibanError, setIbanError] = useState('');
    const [, setSoftwareTypeError] = useState(''); // Software Type is sent with the required default value, but has no visible field.


    const token = sessionStorage.getItem('jwt');
    const clearErrorMessages = () => {
        setMessageErr("");
        setSubtitleErr("");
    };
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));

        switch (name) {
            case 'email':
                setEmailError('');
                break;
            case 'nif':
                setNifError('');
                break;
            case 'name':
                setNameError('');
                break;
            case 'adress':
                setAddressError('');
                break;
            case 'zipCode':
                setZipCodeError('');
                break;
            case 'url':
                setUrlError('');
                break;
        
            case 'bicSwift':
                setBicSwiftError('');
                break;
            case 'iban':
                setIbanError('');
                break;
            // Software Type - ignore - not used, but its not to delete - required to create a new partner (default value is NA)
            case 'softwareType':
                setSoftwareTypeError('');
                break;
            default:
                break;
        }
    };


    const handleSubmit = async (event) => {
        event.preventDefault();
        const normalizedBicSwift = formData.bicSwift
            .replace(/[\s\u200B\uFEFF]+/g, '')
            .toUpperCase();
        // clear all errors before validating
        setEmailError('');
        setNifError('');
        setNameError('');
        setAddressError('');
        setZipCodeError('');
        setUrlError('');
        setIbanError('');
        setBicSwiftError('');
        setSoftwareTypeError(''); // Software Type - ignore - not used, but its not to delete - required to create a new partner (default value is NA)
        setMessageErr("");
        setSubtitleErr("");
        const validationErrors = {
            email: !formData.email ? 'Email obrigatório/incorreto' : '',
            nif: !formData.nif ? 'NIF é obrigatório' : '',
            name: !formData.name ? 'Nome é obrigatório' : '',
            adress: !formData.adress ? 'Morada é obrigatória' : '',
            zipCode: !formData.zipCode ? 'Código postal é obrigatório' : '',
            url: !formData.url ? 'Website é obrigatório' : '',
            iban: !formData.iban ? 'IBAN é obrigatório' : '',
            bicSwift: !normalizedBicSwift
                ? 'BIC/SWIFT é obrigatório'
                : !/^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(normalizedBicSwift)
                    ? 'O BIC/SWIFT deve ter 8 ou 11 caracteres válidos'
                    : '',
            softwareType: !formData.softwareType ? 'Tipo de software é obrigatório' : '',
        };

        setEmailError(validationErrors.email);
        setNifError(validationErrors.nif);
        setNameError(validationErrors.name);
        setAddressError(validationErrors.adress);
        setZipCodeError(validationErrors.zipCode);
        setUrlError(validationErrors.url);
        setIbanError(validationErrors.iban);
        setBicSwiftError(validationErrors.bicSwift);
        setSoftwareTypeError(validationErrors.softwareType);
        // Software Type - ignore - not used, but its not to delete - required to create a new partner (default value is NA)
        if (Object.values(validationErrors).some(Boolean)) {
            return;
        }

        try {
            const payload = {
                ...formData,
                bicSwift: normalizedBicSwift,
                url: normalizeWebsite(formData.url),
            };
            const res = await axios.post(`${URL}/api/partners/create`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });
            if (res.status >= 200 && res.status < 300) {
                setSuccessMessage(res.data?.message || 'Parceiro criado. Foi enviado um link para definir a palavra-passe.');
                setMessageErr("");
                setTimeout(() => {
                    navigate('/admin/parceiros');
                }, 2000);
            } else {
                setMessageErr(res.data.message);
                setSubtitleErr('Verifique os dados e tente novamente.');
                setSuccessMessage("");
            }
        } catch (error) {
            console.error("Error response:", error.response);
            if (error.response) {
                // If the data is a string, use it directly
                const backendMessage = typeof error.response.data === 'string' ? error.response.data : "Erro ao criar o parceiro.";
                setMessageErr(backendMessage);
                setSubtitleErr("Verifique os dados e tente novamente.");
            } else {
                setMessageErr("Não foi possível criar o parceiro.");
                setSubtitleErr("Preencha todos os campos ou verifique se o Parceiro já existe e volte a tentar.");
            }
            setSuccessMessage("");
            setTimeout(() => {
                clearErrorMessages();
            }, 3000);
        }
    };

    const inputClass = (hasError = false) =>
        `h-12 w-full rounded-xl border bg-white px-4 text-sm text-gray-900 shadow-sm outline-none transition placeholder:text-gray-400 ${hasError
            ? 'border-red-300 focus:border-red-500 focus:ring-4 focus:ring-red-100'
            : 'border-gray-200 hover:border-gray-300 focus:border-green-cl focus:ring-4 focus:ring-green-cl/10'
        }`;

    const FieldError = ({ message }) => message ? (
        <p className="mt-1.5 flex items-center gap-1.5 text-xs font-medium text-red-600">
            <ExclamationCircleIcon className="h-4 w-4" />{message}
        </p>
    ) : null;

    const SectionHeading = ({ icon: Icon, title, description }) => (
        <div className="mb-5 flex items-start gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-green-cl/10 text-green-cl">
                <Icon className="h-5 w-5" />
            </span>
            <div>
                <h2 className="text-base font-bold text-gray-900">{title}</h2>
                <p className="mt-0.5 text-sm text-gray-500">{description}</p>
            </div>
        </div>
    );

    return (
        <main className="mx-auto w-full max-w-[1500px] px-5 pb-12 sm:px-8 lg:px-10">
            <div className="pt-5"><Breadcrumb pages={pages} /></div>
            <Tooltip />

            <div className="fixed inset-x-0 top-0 z-50 w-full">
                {successMessage && <SuccessMessage message={successMessage} />}
                {messageErr && <ErrorMessage messageErr={messageErr} subtitleErr={subtitleErr} duration={2000} className="w-full" />}
            </div>

            <header className="mb-7 mt-8">
                <span className="text-xs font-bold uppercase tracking-[0.24em] text-green-cl">Gestão de parceiros</span>
                <h1 className="mt-2 text-3xl font-black tracking-tight text-gray-950 sm:text-4xl">Novo parceiro</h1>
                <p className="mt-2 max-w-2xl text-sm text-gray-500 sm:text-base">Registe os dados da empresa, o email de acesso e a informação bancária.</p>
            </header>

            <form onSubmit={handleSubmit} className="overflow-hidden rounded-3xl border border-gray-100 bg-white shadow-xl shadow-gray-200/60">
                <div className="grid gap-8 p-6 sm:p-8 xl:grid-cols-2 xl:p-10">
                    <section className="rounded-2xl border border-gray-100 bg-gray-50/60 p-5 sm:p-6">
                        <SectionHeading icon={BuildingOffice2Icon} title="Identificação da empresa" description="Informação fiscal e comercial do parceiro." />
                        <div className="grid gap-5 sm:grid-cols-2">
                            <div>
                                <label htmlFor="name" className="mb-2 block text-sm font-semibold text-gray-700">Nome da empresa</label>
                                <input id="name" name="name" value={formData.name} onChange={handleChange} placeholder="Ex.: Empresa, Lda." className={inputClass(nameError)} />
                                <FieldError message={nameError} />
                            </div>
                            <div>
                                <label htmlFor="nif" className="mb-2 block text-sm font-semibold text-gray-700">NIF</label>
                                <div className="relative"><IdentificationIcon className="absolute left-4 top-3.5 h-5 w-5 text-gray-400" /><input id="nif" name="nif" inputMode="numeric" value={formData.nif} onChange={handleChange} placeholder="9 dígitos" className={`${inputClass(nifError)} pl-11`} /></div>
                                <FieldError message={nifError} />
                            </div>
                            <div className="sm:col-span-2">
                                <label htmlFor="url" className="mb-2 block text-sm font-semibold text-gray-700">Website</label>
                                <div className="relative"><GlobeAltIcon className="absolute left-4 top-3.5 h-5 w-5 text-gray-400" /><input id="url" name="url" type="text" inputMode="url" autoCapitalize="none" spellCheck={false} value={formData.url} onChange={handleChange} placeholder="empresa.pt ou https://empresa.pt" className={`${inputClass(urlError)} pl-11`} /></div>
                                <FieldError message={urlError} />
                            </div>
                        </div>
                    </section>

                    <section className="rounded-2xl border border-gray-100 bg-gray-50/60 p-5 sm:p-6">
                        <SectionHeading icon={LockClosedIcon} title="Acesso à plataforma" description="O parceiro receberá por email um link para definir a própria palavra-passe." />
                        <div className="space-y-5">
                            <div>
                                <label htmlFor="email" className="mb-2 block text-sm font-semibold text-gray-700">Email</label>
                                <div className="relative"><EnvelopeIcon className="absolute left-4 top-3.5 h-5 w-5 text-gray-400" /><input id="email" name="email" type="email" autoComplete="email" value={formData.email} onChange={handleChange} placeholder="nome@empresa.pt" className={`${inputClass(emailError)} pl-11`} /></div>
                                <FieldError message={emailError} />
                            </div>
                            <div className="rounded-xl border border-emerald-100 bg-emerald-50/70 px-4 py-3 text-sm leading-5 text-emerald-800">
                                A palavra-passe será definida pelo próprio parceiro através do link seguro enviado para este email.
                            </div>
                        </div>
                    </section>

                    <section className="rounded-2xl border border-gray-100 bg-gray-50/60 p-5 sm:p-6">
                        <SectionHeading icon={MapPinIcon} title="Contacto e localização" description="Morada associada à empresa." />
                        <div className="grid gap-5 sm:grid-cols-3">
                            <div className="sm:col-span-2"><label htmlFor="adress" className="mb-2 block text-sm font-semibold text-gray-700">Morada</label><input id="adress" name="adress" value={formData.adress} onChange={handleChange} placeholder="Rua, número e localidade" className={inputClass(adressError)} /><FieldError message={adressError} /></div>
                            <div><label htmlFor="zipCode" className="mb-2 block text-sm font-semibold text-gray-700">Código postal</label><input id="zipCode" name="zipCode" value={formData.zipCode} onChange={handleChange} placeholder="0000-000" className={inputClass(zipCodeError)} /><FieldError message={zipCodeError} /></div>
                        </div>
                    </section>

                    <section className="rounded-2xl border border-gray-100 bg-gray-50/60 p-5 sm:p-6">
                        <SectionHeading icon={BanknotesIcon} title="Dados bancários" description="Informação necessária para movimentos financeiros." />
                        <div className="grid gap-5 sm:grid-cols-3">
                            <div><label htmlFor="bicSwift" className="mb-2 block text-sm font-semibold text-gray-700">BIC/SWIFT</label><input id="bicSwift" name="bicSwift" value={formData.bicSwift} onChange={handleChange} placeholder="Ex.: BESCPTPL" maxLength={14} className={`${inputClass(bicSwiftError)} uppercase`} /><FieldError message={bicSwiftError} /></div>
                            <div className="sm:col-span-2"><label htmlFor="iban" className="mb-2 block text-sm font-semibold text-gray-700">IBAN</label><input id="iban" name="iban" value={formData.iban} onChange={handleChange} placeholder="PT50 0000 0000 0000 0000 0000 0" className={`${inputClass(ibanError)} uppercase`} /><FieldError message={ibanError} /></div>
                        </div>
                    </section>

                    <section className="xl:col-span-2">
                        <label htmlFor="notes" className="mb-2 block text-sm font-semibold text-gray-700">Notas <span className="font-normal text-gray-400">(opcional)</span></label>
                        <textarea id="notes" name="notes" rows={4} value={formData.notes} onChange={handleChange} placeholder="Adicione informação relevante sobre o parceiro..." className="w-full resize-y rounded-2xl border border-gray-200 bg-white px-4 py-3 text-sm text-gray-900 shadow-sm outline-none transition placeholder:text-gray-400 hover:border-gray-300 focus:border-green-cl focus:ring-4 focus:ring-green-cl/10" />
                    </section>
                </div>

                <div className="flex flex-col-reverse gap-3 border-t border-gray-100 bg-gray-50/70 px-6 py-5 sm:flex-row sm:items-center sm:justify-end sm:px-10">
                    <Link to="/admin/parceiros" className="inline-flex h-12 items-center justify-center rounded-xl border border-gray-300 bg-white px-6 text-sm font-bold text-gray-700 shadow-sm transition hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-green-cl focus:ring-offset-2">Cancelar</Link>
                    <button type="submit" className="inline-flex h-12 items-center justify-center rounded-xl bg-green-cl px-7 text-sm font-bold text-white shadow-md transition hover:-translate-y-0.5 hover:bg-green-900 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-green-cl focus:ring-offset-2">Criar parceiro</button>
                </div>
            </form>
        </main>
    )
}
